<template>
  <div>
    <v-dialog
      v-model="isShowDialog"
      persistent
      :width="matchPanelSize"
      transition="dialog-transition"
      v-if="getSelectedDevice != null"
    >
      <v-card>
        <v-card-title class="d-flex justify-space-between ">
          <span>OBJECT DATA <br v-if="$vuetify.breakpoint.name == 'xs'"> ({{ getSelectedDevice?.name }}, ID:{{ getSelectedDevice?.id }})</span>
          <div>
            <v-btn 
              :disabled="loading"
              outlined
              @click="hideObjectData"
              class="text-body-2 text-md-subtitle-2 text-lg-subtitle-1 text-xl-subtitle-h6"
              :x-large="$vuetify.breakpoint.name == 'xl'"
              :large="$vuetify.breakpoint.name == 'lg'"
            >
              <v-icon color="white">
                mdi-close
              </v-icon>
            </v-btn>
          </div>
        </v-card-title>
        <v-card-text>
          <v-row class="mt-2">
            <v-col class="col-12 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <v-row>
                <v-col class="col-6">
                  <v-select
                    :disabled="true"
                    outlined
                    v-model="SubjectCreationDto.DeviceTypeId"
                    :items="getDeviceTypes"
                    item-text="name"
                    item-value="id"
                    :menu-props="{ maxHeight: '400', offsetY: true }"
                    label="Device"
                    persistent-hint
                    dense
                    hide-details
                  ></v-select>
                </v-col>
                <v-col class="col-6">
                  <v-text-field
                    :disabled="true"
                    label="DVC-Point IMEI"
                    outlined
                    v-model="SubjectCreationDto.DeviceImei"
                    persistent-hint
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col class="col-6">
                  <v-text-field
                    :disabled="true"
                    label="SIM object phone number"
                    outlined
                    v-model="SubjectCreationDto.PhoneNumber"
                    persistent-hint
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col class="col-6">
                  <v-select
                    :disabled="true"
                    outlined
                    v-model="SubjectCreationDto.SubDeviceTypeId"
                    :items="getSubDeviceTypes"
                    item-text="name"
                    item-value="id"
                    :menu-props="{ maxHeight: '400', offsetY: true }"
                    label="Object type"
                    persistent-hint
                    dense
                    hide-details
                  ></v-select>
                </v-col>
                <v-col class="col-6" v-if="(SubjectCreationDto.SubDeviceTypeId == 1 || SubjectCreationDto.SubDeviceTypeId == 2 || SubjectCreationDto.SubDeviceTypeId == 3)">
                  <v-text-field
                    :disabled="true"
                    label="Serial Number"
                    outlined
                    v-model="SubjectCreationDto.SubDeviceSerialNumber"
                    persistent-hint
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col class="col-6">
                  <v-text-field
                    :disabled="true"
                    label="Device ID"
                    outlined
                    v-model="trueID"
                    persistent-hint
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col :class="(SubjectCreationDto.SubDeviceTypeId == 1 || SubjectCreationDto.SubDeviceTypeId == 2 || SubjectCreationDto.SubDeviceTypeId == 3) ? 'col-12' : 'col-6'">
                  <v-text-field
                    :disabled="(loading || !isEditDeviceFields || !isEditMode)"
                    label="Polling TimeOut"
                    outlined
                    v-model="SubjectCreationDto.ModuleAConfig.PollingTimeOut"
                    persistent-hint
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col class="col-4" v-if="getDeviceMapState.filter(map => map.DeviceId == selectedDevice?.deviceId).length > 0">
                  <v-text-field
                    :disabled="true"
                    label="Latitude"
                    outlined
                    v-model="getDeviceMapState.filter(map => map.DeviceId == selectedDevice?.deviceId)[0].Latitude"
                    persistent-hint
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col class="col-4" v-if="getDeviceMapState.filter(map => map.DeviceId == selectedDevice?.deviceId).length > 0">
                  <v-text-field
                    :disabled="true"
                    label="Longitude"
                    outlined
                    v-model="getDeviceMapState.filter(map => map.DeviceId == selectedDevice?.deviceId)[0].Longitude"
                    persistent-hint
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
                <v-col class="col-4" v-if="getDeviceMapState.filter(map => map.DeviceId == selectedDevice?.deviceId).length > 0">
                  <v-text-field
                    :disabled="true"
                    label="Altitude"
                    outlined
                    v-model="getDeviceMapState.filter(map => map.DeviceId == selectedDevice?.deviceId)[0].Altitude"
                    persistent-hint
                    dense
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
            <v-col class="col-12 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <v-row>
                <v-col class="col-12 d-flex justify-center">
                  <v-btn :disabled="loading" depressed outlined @click="pushPoint"
                    class="text-body-2 text-md-subtitle-2 text-lg-subtitle-1 text-xl-subtitle-h6 mb-1">
                    PUSH
                  </v-btn>
                </v-col>
                <v-col class="col-12 d-flex justify-center">
                  <v-btn :disabled="dOutIsOn" depressed outlined
                    class="text-body-2 text-md-subtitle-2 text-lg-subtitle-1 text-xl-subtitle-h6 mb-1">
                    OUT SIGNAL
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col class="col-12">
              <hr class="info">
            </v-col>
          </v-row>
          <v-row no-gutters class="d-flex justify-center">
            <v-col class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
              <v-row no-gutters class="d-flex justify-space-around">
                <!--START MODULEA-->
                <v-col class="col-12 mt-2" v-if="(SubjectCreationDto.SubDeviceTypeId == 4)">
                  <v-row>
                    <v-col :class="$vuetify.breakpoint.name == 'xs' ? 'col-6' : 'col-4'">
                      <v-text-field
                        class="mt-3"
                        :disabled="(loading || !isEditDeviceFields)"
                        label="Enter temperature sensor name"
                        outlined
                        v-model="SubjectCreationDto.ModuleAConfig.TemperatureName"
                        persistent-hint
                        dense
                        hide-details
                      ></v-text-field>
                      <v-text-field
                        class="mt-3"
                        :disabled="(loading || !isEditDeviceFields)"
                        label="Enter sensor name"
                        outlined
                        v-model="SubjectCreationDto.ModuleAConfig.Adc1.Name"
                        persistent-hint
                        dense
                        hide-details
                      ></v-text-field>
                      <v-text-field
                        class="mt-3"
                        :disabled="(loading || !isEditDeviceFields)"
                        label="Enter sensor name"
                        outlined
                        v-model="SubjectCreationDto.ModuleAConfig.Adc2.Name"
                        persistent-hint
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col :class="$vuetify.breakpoint.name == 'xs' ? 'col-6' : 'col-4'">
                      <v-select
                        class="mt-3"
                        :disabled="true"
                        outlined
                        v-model="selected"
                        :items="[{name: 'Temperature', id: 1}]"
                        item-text="name"
                        item-value="id"
                        :menu-props="{ maxHeight: '400', offsetY: true }"
                        label="Sensor type"
                        persistent-hint
                        dense
                        hide-details
                      ></v-select>
                      <v-select
                        class="mt-3"
                        :disabled="(loading || !isEditDeviceFields)"
                        outlined
                        v-model="SubjectCreationDto.ModuleAConfig.Adc1.DescriptorTypeId"
                        :items="getSubjectCreationDatas.descriptors"
                        item-text="name"
                        item-value="id"
                        :menu-props="{ maxHeight: '400', offsetY: true }"
                        label="Sensor type"
                        persistent-hint
                        dense
                        hide-details
                      ></v-select>
                      <v-select
                        class="mt-3"
                        :disabled="(loading || !isEditDeviceFields)"
                        outlined
                        v-model="SubjectCreationDto.ModuleAConfig.Adc2.DescriptorTypeId"
                        :items="getSubjectCreationDatas.descriptors"
                        item-text="name"
                        item-value="id"
                        :menu-props="{ maxHeight: '400', offsetY: true }"
                        label="Sensor type"
                        persistent-hint
                        dense
                        hide-details
                      ></v-select>
                    </v-col>
                    <v-col :class="$vuetify.breakpoint.name == 'xs' ? 'col-6' : 'col-2'">
                      <v-text-field
                        class="mt-3"
                        :disabled="true"
                        label="Multiplier"
                        value="1"
                        outlined
                        persistent-hint
                        dense
                        hide-details
                      ></v-text-field>
                      <v-text-field
                        class="mt-3"
                        label="Multiplier"
                        outlined
                        disabled
                        v-model="getMultiplierByDescriptorTypeIdAdc1"
                        persistent-hint
                        dense
                        hide-details
                      ></v-text-field>
                      <v-text-field
                        class="mt-3"
                        label="Multiplier"
                        outlined
                        disabled
                        v-model="getMultiplierByDescriptorTypeIdAdc2"
                        persistent-hint
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col :class="$vuetify.breakpoint.name == 'xs' ? 'col-6' : 'col-2'">
                      <v-text-field
                        class="mt-3"
                        :disabled="true"
                        label="Measure type"
                        value="C"
                        outlined
                        persistent-hint
                        dense
                        hide-details
                      ></v-text-field>
                      <v-text-field
                        class="mt-3"
                        label="Measure type"
                        outlined
                        disabled
                        v-model="getMeasureTypeNameAdc1"
                        persistent-hint
                        dense
                        hide-details
                      ></v-text-field>
                      <v-text-field
                        class="mt-3"
                        label="Measure type"
                        outlined
                        disabled
                        v-model="getMeasureTypeNameAdc2"
                        persistent-hint
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-col>
                <!--END MODULEA-->
                <v-col class="col-12 mt-3" v-if="getSubjectCreationDatas">
                  <v-row>
                    <v-col :class="$vuetify.breakpoint.name == 'xs' ? 'col-6' : 'col-3'">
                      <v-text-field
                        :disabled="(loading || !isEditDeviceFields || !isEditMode)"
                        label="Object title"
                        outlined
                        v-model="SubjectCreationDto.Name"
                        persistent-hint
                        dense
                        hide-details
                      ></v-text-field>
                      <v-text-field
                        class="mt-5"
                        :disabled="(loading || !isEditDeviceFields || !isEditMode)"
                        label="Object address"
                        outlined
                        v-model="fullAddress"
                        @change="fullAddressChange"
                        persistent-hint
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-col :class="$vuetify.breakpoint.name == 'xs' ? 'col-6' : 'col-3'">
                      <v-select
                        :disabled="(loading || !isEditDeviceFields)"
                        outlined
                        v-model="SubjectCreationDto.SupplierId"
                        :items="getSubjectCreationDatas.suppliers.map(item => ({id: item?.id, title: item.title, disabled: !isEditMode}))"
                        item-text="title"
                        item-value="id"
                        :menu-props="{ maxHeight: '400', offsetY: true }"
                        label="Resource supplier"
                        persistent-hint
                        dense
                        hide-details
                      ></v-select>
                      <v-select
                        :disabled="true"
                        class="mt-5"
                        outlined
                        v-model="SubjectCreationDto.TarifId"
                        :items="getSubjectCreationDatas.tariffs"
                        item-text="fakeName"
                        item-value="id"
                        :menu-props="{ maxHeight: '400', offsetY: true }"
                        label="Tariff"
                        persistent-hint
                        dense
                        hide-details
                      ></v-select>
                    </v-col>
                    <v-col :class="$vuetify.breakpoint.name == 'xs' ? 'col-6' : 'col-3'">
                      <v-select
                        :disabled="(loading || !isEditDeviceFields)"
                        outlined
                        v-model="SubjectCreationDto.SimCorpId"
                        :items="getSubjectCreationDatas.simCorps.map(item => ({id: item?.id, name: item.name, disabled: !isEditMode}))"
                        item-text="name"
                        item-value="id"
                        :menu-props="{ maxHeight: '400', offsetY: true }"
                        label="Sim corporation"
                        persistent-hint
                        dense
                        hide-details
                      ></v-select>
                      <v-select
                        class="mt-5"
                        :disabled="(loading || !isEditDeviceFields)"
                        outlined
                        v-model="SubjectCreationDto.ProviderId"
                        :items="getSubjectCreationDatas.providers.map(item => ({name: item.name, id: item?.id, disabled: !isEditMode}))"
                        item-text="name"
                        item-value="id"
                        :menu-props="{ maxHeight: '400', offsetY: true }"
                        label="Internet provider"
                        persistent-hint
                        dense
                        hide-details
                      ></v-select>
                    </v-col>
                    <v-col :class="$vuetify.breakpoint.name == 'xs' ? 'col-6' : 'col-3'">
                      <v-select
                        :disabled="(loading || !isEditDeviceFields)"
                        outlined
                        v-model="SubjectCreationDto.IsBatteryPower"
                        :items="powerType.map(item => ({name: item.name, value: item.value, disabled: !isEditMode}))"
                        item-text="name"
                        item-value="value"
                        :menu-props="{ maxHeight: '400', offsetY: true }"
                        label="Power type"
                        persistent-hint
                        dense
                        hide-details
                      ></v-select>
                      <v-select
                        class="mt-5"
                        :disabled="(loading || !isEditDeviceFields)"
                        outlined
                        v-model="SubjectCreationDto.ImportanceRank"
                        :items="getSubjectCreationDatas.importanceRank.map(item => ({name: item.name, id: item?.id, disabled: !isEditMode}))"
                        item-text="name"
                        item-value="id"
                        :menu-props="{ maxHeight: '400', offsetY: true }"
                        label="Importance rank"
                        persistent-hint
                        dense
                        hide-details
                      ></v-select>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row no-gutters class="mt-4">
                <v-col class="col-6 d-flex justify-start">
                </v-col>
                <v-col class="col-6 d-flex justify-end">
                  <v-btn depressed outlined @click="removeObject(getSelectedDevice)"
                    class="mr-4 text-body-2 text-md-subtitle-2 text-lg-subtitle-1 text-xl-subtitle-h6"
                    :x-large="$vuetify.breakpoint.name == 'xl'"
                    :large="$vuetify.breakpoint.name == 'lg'">
                    REMOVE
                  </v-btn>
                  <v-btn v-if="isEditMode" depressed outlined @click="cancelEdit"
                    class="mr-4 text-body-2 text-md-subtitle-2 text-lg-subtitle-1 text-xl-subtitle-h6"
                    :x-large="$vuetify.breakpoint.name == 'xl'"
                    :large="$vuetify.breakpoint.name == 'lg'">
                    Cancel
                  </v-btn>
                  <v-btn v-if="isEditMode" :disabled="loading || isNotValidStep1 || isNotValidStep2" depressed outlined @click="updateSupplier"
                    class="text-body-2 text-md-subtitle-2 text-lg-subtitle-1 text-xl-subtitle-h6"
                    :x-large="$vuetify.breakpoint.name == 'xl'"
                    :large="$vuetify.breakpoint.name == 'lg'">
                    SAVE
                  </v-btn>
                  <v-btn depressed outlined @click="isEditMode = true" v-if="!isEditMode"
                    class="text-body-2 text-md-subtitle-2 text-lg-subtitle-1 text-xl-subtitle-h6"
                    :x-large="$vuetify.breakpoint.name == 'xl'"
                    :large="$vuetify.breakpoint.name == 'lg'">
                    EDIT
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="isStartRemoveObject"
      persistent
      max-width="290"
      v-if="getSelectedDevice != null"
    >
      <v-card>
        <v-card-title class="text-h5">
          Are you sure?
        </v-card-title>

        <v-card-text>
          Remove {{ getSelectedDevice.name }}, ID: {{ getSelectedDevice.id }}?
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed outlined @click="isStartRemoveObject = false"
            class="mr-4 text-body-2 text-md-subtitle-2 text-lg-subtitle-1 text-xl-subtitle-h6"
            :x-large="$vuetify.breakpoint.name == 'xl'"
            :large="$vuetify.breakpoint.name == 'lg'">
            Disagree
          </v-btn>
          <v-btn depressed outlined @click="removeCallObject(getSelectedDevice)"
            class="text-body-2 text-md-subtitle-2 text-lg-subtitle-1 text-xl-subtitle-h6"
            :x-large="$vuetify.breakpoint.name == 'xl'"
            :large="$vuetify.breakpoint.name == 'lg'">
            Agree
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { nextTick } from 'vue'
import {mapGetters, mapActions, mapMutations} from 'vuex'
  export default {
    props: ['isShowDialog'],
    name: 'ObjectData',
    data(){
      return {
        isStartRemoveObject: false,
        connectionControl: null,
        commands: [':01.03.12*70.01.00', ':01.03.12*70.02.00'],
        dOutIsOn: true,
        isEditMode: false,
        selected: 1,
        trueID: null,
        fullAddress: '',
        step: 1,
        isEditDeviceFields: true,
        selectedDeviceSensors: null,
        selectedDeviceType: null,
        selectedDevice: null,
        loading: false,
        powerType:[
          {
            name: 'Battery',
            value: true
          },
          {
            name: 'PowerSupply',
            value: false
          }
        ],
        SubjectCreationDto:{
          DeviceTypeId: '',
          DeviceImei: '',
          PhoneNumber: '',
          SubDeviceTypeId: 0,
          SubDeviceSerialNumber: '',
          MeterNetworkNumber:'',
          ModuleAConfig:{
            PollingTimeOut: 0,
            TemperatureName: '',
            Adc1:{
              Name: '',
              DescriptorTypeId: 0,
            },
            Adc2:{
              Name: '',
              DescriptorTypeId: 0,
            }
          },
          Name: '',
          FullAddress: {
            FullAddress: null,
            Latitude: null,
            Longitude: null,
            Country: null,
            Area: null,
            City: null,
            Street: null,
            House: null
          },
          SupplierId: 0,
          TarifId: 0,
          ProviderId: 0,
          IsBatteryPower: false,
          ImportanceRank: '',
          SimCorpId: 0
        }
      }
    },
    computed:{
      ...mapGetters(['getDeviceTypes', 'getSubDeviceTypes', 'getSubjectCreationDatas', 
      'getTariffs', 'getDeviceMapState', 'getSelectedDevice', 'getConnection']),
      matchPanelSize(){
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': return '100%'
          case 'sm': return '80%'
          case 'md': return '70%'
          case 'lg': return '50%'
          case 'xl': return '35%'
        }
      },
      isNotValidStep1(){
        console.log(this.SubjectCreationDto)
        if(this.SubjectCreationDto.DeviceTypeId > 0 && this.SubjectCreationDto.PhoneNumber.length > 6 && this.SubjectCreationDto.SubDeviceTypeId > 0){
          if(this.SubjectCreationDto.SubDeviceTypeId == 1 && this.SubjectCreationDto.SubDeviceSerialNumber.length > 4){
            console.log('#1')
            return false
          }
          if(this.SubjectCreationDto.SubDeviceTypeId == 2 && this.SubjectCreationDto.SubDeviceSerialNumber.length > 4/* && this.SubjectCreationDto.MeterNetworkNumber.length > 1*/){
            console.log('#2')
            return false
          }
          if(this.SubjectCreationDto.SubDeviceTypeId == 3 && this.SubjectCreationDto.SubDeviceSerialNumber.length > 4){
            console.log('#3')
            return false
          }
          if((this.SubjectCreationDto.SubDeviceTypeId == 4) && this.SubjectCreationDto.ModuleAConfig.TemperatureName.length > 1
          && this.SubjectCreationDto.ModuleAConfig.Adc1.Name.length > 1 && this.SubjectCreationDto.ModuleAConfig.Adc2.Name.length > 1
          && this.SubjectCreationDto.ModuleAConfig.Adc1.DescriptorTypeId > 0 && this.SubjectCreationDto.ModuleAConfig.Adc2.DescriptorTypeId > 0){
            console.log('#4')
            return false
          }
          if(this.SubjectCreationDto.SubDeviceTypeId == 5 && this.SubjectCreationDto.SubDeviceSerialNumber.length >= 4){
            console.log('#5')
            return false
          }
        }
        console.log('#6')
        return true
      },
      isNotValidStep2(){
        console.log(this.SubjectCreationDto.Name.length > 3, this.fullAddress != ''
         , this.SubjectCreationDto.SupplierId > 0, this.SubjectCreationDto.TarifId > 0
         , this.SubjectCreationDto.SimCorpId > 0, this.SubjectCreationDto.ImportanceRank > 0)

        if(this.SubjectCreationDto.Name.length > 3 && this.fullAddress != ''
         && this.SubjectCreationDto.SupplierId > 0 && this.SubjectCreationDto.TarifId > 0
         && this.SubjectCreationDto.SimCorpId > 0 && this.SubjectCreationDto.ImportanceRank > 0
          && this.SubjectCreationDto.ModuleAConfig.PollingTimeOut >= 1 && this.SubjectCreationDto.ModuleAConfig.PollingTimeOut <= 5){
            console.log('#5')
          return false
        }
        return true
      },
      getMultiplierByDescriptorTypeIdAdc1(){
        const desc = this.getSubjectCreationDatas.descriptors.filter(d => d?.id == this.SubjectCreationDto.ModuleAConfig.Adc1.DescriptorTypeId)
        if(desc.length == 0){
          return null
        }else{
          return desc[0].multiplier
        }
      },
      getMultiplierByDescriptorTypeIdAdc2(){
        const desc = this.getSubjectCreationDatas.descriptors.filter(d => d?.id == this.SubjectCreationDto.ModuleAConfig.Adc2.DescriptorTypeId)
        if(desc.length == 0){
          return null
        }else{
          return desc[0].multiplier
        }
      },
      getMeasureTypeNameAdc1(){
        const descriptor = this.getSubjectCreationDatas.descriptors.filter(d => d?.id == this.SubjectCreationDto.ModuleAConfig.Adc1.DescriptorTypeId)
        if(descriptor.length == 0){
          return null
        }
        console.log(descriptor)
        const desc = this.getSubjectCreationDatas.measureTypes.filter(d => d?.id == descriptor[0].measureTypeId)
        console.log(desc)
        if(desc.length == 0){
          return null
        }else{
          return desc[0].value
        }
      },
      getMeasureTypeNameAdc2(){
        const descriptor = this.getSubjectCreationDatas.descriptors.filter(d => d?.id == this.SubjectCreationDto.ModuleAConfig.Adc2.DescriptorTypeId)
        if(descriptor.length == 0){
          return null
        }
        const desc = this.getSubjectCreationDatas.measureTypes.filter(d => d?.id == descriptor[0].measureTypeId)
        if(desc.length == 0){
          return null
        }else{
          return desc[0].value
        }
      }
    },
    async mounted(){
      await this.$root.$on("showObjectData", async (device) => {
        this.selectedDevice = device
        this.$root.$on('HubCommand', (message) => {
          if(message == 'M2 command performed'){
            this.dOutIsOn = false
            setTimeout(() => {
              this.dOutIsOn = true
            }, 1500)
          }
        })
        await this.loadDeviceSensors()
      })
    },
    methods:{
      ...mapActions(['createUserByAgregator', 'getLocationInfo', 'updateSubject', 'getDeviceSensors', 'removeObjectAction']),
      async removeCallObject(item){
        this.$root.$emit('loading', "start")
        await this.removeObjectAction(item?.id)
        .then(result => {
          this.$root.$emit('loading', "end")
          location.reload()
        })
        .catch(e => {
          console.log(e)
          this.$root.$emit('globalError', e.code)
          this.$root.$emit('loading', "end")
        })
      },
      removeObject(item){
        this.isStartRemoveObject = true
        console.log(item)
      },
      pushPoint(){
        this.commands.forEach(command => {
          this.sendMessage(command)
        })
      },
      sendMessage(message){
        if(this.getConnection?.state == 'Connected'){
          try {
            this.getConnection
            .invoke("Command", {
              Imei: this.selectedDevice.device.imei,
              Command: message
            })
          } catch (e) {
            console.log(e)
          }
        }
      },
      cancelEdit(){
        this.isEditMode = false
        this.deviceRefreshFields()
      },
      async loadDeviceSensors(){
        this.$root.$emit('loading', "start")
        const trueId = `000${this.selectedDevice?.id}`
        this.trueID = `DVC ${trueId.substring(trueId.length-3, trueId.length)}`
        await this.getDeviceSensors(this.selectedDevice?.id)
        .then(result => {
          if(result.result.code == 0){
            this.selectedDeviceSensors = result.sensorTypesDtos
            this.deviceRefreshFields()
          }
          this.$root.$emit('loading', "end")
        })
        .catch(e => {
          console.log(e)
          this.$root.$emit('globalError', e.code)
          this.$root.$emit('loading', "end")
        })
      },
      deviceRefreshFields(){
        this.SubjectCreationDto.ModuleAConfig.PollingTimeOut = this.selectedDevice.pollingTimeout

        this.SubjectCreationDto.SubDeviceSerialNumber = this.selectedDevice.subDevice.serialNumber
        this.SubjectCreationDto.DeviceTypeId = this.selectedDevice.device.deviceTypeId
        this.SubjectCreationDto.DeviceImei = this.selectedDevice.device.imei
        this.SubjectCreationDto.PhoneNumber = this.selectedDevice.device.phoneNumber
        this.SubjectCreationDto.SubDeviceTypeId = this.selectedDevice.subDevice.typeId
        this.SubjectCreationDto.Name = this.selectedDevice.name
        this.SubjectCreationDto.ImportanceRank = this.selectedDevice.importanceRank
        this.SubjectCreationDto.IsBatteryPower = this.selectedDevice.device.isBatteryPower
        this.SubjectCreationDto.SupplierId = this.selectedDevice.supplierId
        const network = this.getSubjectCreationDatas.networks.filter(network => network?.id == this.selectedDevice.networkId)
        console.error(network)
        if(network.length > 0){
          this.SubjectCreationDto.ProviderId = network[0].providerId
          this.SubjectCreationDto.SimCorpId = network[0].simCorpId
        }
        this.SubjectCreationDto.FullAddress.Latitude = this.selectedDevice.address.latitude
        this.SubjectCreationDto.FullAddress.Longitude = this.selectedDevice.address.longitude
        this.SubjectCreationDto.FullAddress.Country = this.selectedDevice.address.country
        this.SubjectCreationDto.FullAddress.Area = this.selectedDevice.address.area
        this.SubjectCreationDto.FullAddress.City = this.selectedDevice.address.city
        this.SubjectCreationDto.FullAddress.Street = this.selectedDevice.address.street
        this.SubjectCreationDto.FullAddress.House = this.selectedDevice.address.house
        this.fullAddress = `${this.selectedDevice.address.country}, ${this.selectedDevice.address.city}, ${this.selectedDevice.address.fullAddress}`
        this.SubjectCreationDto.FullAddress.FullAddress = this.fullAddress

        const findTariffBySupplier = this.getSubjectCreationDatas.tariffs.filter(tariff => tariff.supplierId == this.SubjectCreationDto.SupplierId)
        console.log(this.getSubjectCreationDatas.tariffs)
        console.log(this.SubjectCreationDto.SupplierId)
        console.log(findTariffBySupplier)

        if(findTariffBySupplier.length > 0){
          this.SubjectCreationDto.TarifId = findTariffBySupplier[0]?.id
        }
        //ModuleA
        if(this.selectedDevice.subDevice.typeId == 4 && this.selectedDeviceSensors.length == 3){
          console.log(this.selectedDeviceSensors)
          this.selectedDeviceSensors.forEach(sd => {
            if(sd.sensorTypeId == 74){
              this.SubjectCreationDto.ModuleAConfig.TemperatureName = sd.sensorName
            }
            if(sd.sensorTypeId == 75){
              this.SubjectCreationDto.ModuleAConfig.Adc1.Name = sd.sensorName
              this.SubjectCreationDto.ModuleAConfig.Adc1.DescriptorTypeId = sd.typeId
            }
            if(sd.sensorTypeId == 76){
              this.SubjectCreationDto.ModuleAConfig.Adc2.Name = sd.sensorName
              this.SubjectCreationDto.ModuleAConfig.Adc2.DescriptorTypeId = sd.typeId
            }
            console.log(this.SubjectCreationDto)
          })
        }
      },
      hideObjectData(){
        this.step = 1
        this.$emit('hideObjectData')
      },
      async fullAddressChange(){
        await this.getLocationInfo(this.fullAddress)
        .then(result => {
          if(result.data && result.data.length > 0){
            const fullInfoAddress = result.data[0]
            this.SubjectCreationDto.FullAddress.FullAddress = fullInfoAddress.display_name
            this.SubjectCreationDto.FullAddress.Latitude = fullInfoAddress.lat
            this.SubjectCreationDto.FullAddress.Longitude = fullInfoAddress.lon
            this.SubjectCreationDto.FullAddress.Country = fullInfoAddress.address.country
            this.SubjectCreationDto.FullAddress.Area = fullInfoAddress.address.state
            this.SubjectCreationDto.FullAddress.City = fullInfoAddress.address.city
            this.SubjectCreationDto.FullAddress.Street = fullInfoAddress.address.road
            this.SubjectCreationDto.FullAddress.House = fullInfoAddress.address.house_number
            this.fullAddress = fullInfoAddress.display_name
          }
        })
        .catch(e => {
          console.log(e)
        })
      },
      async updateSupplier(){
        this.$root.$emit('loading', "start")
        console.log(this.SubjectCreationDto)
        await this.updateSubject(this.SubjectCreationDto)
        .then(async res => {
          console.log(res)
          this.$root.$emit('loading', "end")
          this.$noty.success(`Success`)
          this.cancelEdit()
          this.$emit('hideObjectData')
          this.$root.$emit('HideMarkerClick')
          this.$root.$emit('refreshDevices')
        })
        .catch(er => {
          console.log(er)
          this.$root.$emit('loading', "end")
          this.$noty.error(`Error: ${er.description}`)
        })
      }
    }
  }
</script>
